import styled from "styled-components";

export const LineChartWrapper = styled.div``;
